import clsx from 'clsx'
import PropTypes from 'prop-types'

import FlatLink from '../FlatLink'

import styles from './style.module.scss'

/*
 * Überschrift eines Abschnitts auf einem Dashboard.
 *
 * Es gab sie zweimal in verschiedener Gestalt: „Mitteilungen" stand in 20 px
 * und Schriftschnitt 300, „Veranstaltungen und Neuigkeiten" darunter in 22 px
 * und 600, mit Trennlinie. Zwei gleichrangige Abschnitte untereinander sahen
 * damit aus wie Haupt- und Nebensache — dabei ist es nur derselbe Rang, zweimal
 * verschieden geschrieben.
 *
 * Wer einen Abschnitt dazubaut, nimmt diese Komponente, statt die Überschrift
 * noch einmal zu setzen.
 */
export default function SectionHead({ title, count, linkTo, linkLabel, className }) {
	return (
		<header className={clsx(styles.root, className)}>
			<h2 className={styles.title}>
				{title}
				{/* Null ist eine Auskunft, aber keine, für die es ein Abzeichen braucht. */}
				{!!count && <span className={styles.count}>{count}</span>}
			</h2>

			{!!linkTo && (
				<FlatLink
					className={styles.link}
					color="#303e65"
					iconColor="#008B9C"
					iconSize={{ w: 8, h: 8 }}
					to={linkTo}
					icon="arrow"
				>
					{linkLabel}
				</FlatLink>
			)}
		</header>
	)
}

SectionHead.propTypes = {
	title: PropTypes.string.isRequired,
	// Zahl neben dem Titel (etwa ungelesene Mitteilungen).
	count: PropTypes.number,
	linkTo: PropTypes.string,
	linkLabel: PropTypes.string,
	className: PropTypes.string
}
